import { GRID_DETAIL_PANEL_TOGGLE_COL_DEF } from '@mui/x-data-grid-pro';
import CustomDetailPanelToggle from '../CustomDetailPanelToggle';
import { formatDate } from 'views/Components/Shared/utils/formatDate';
import InfoField from '../InfoFiel';
import { months, monthsNames } from 'views/Components/Forecast/utils/monhts';
import MonthDataField from '../MonthDataField';
import EmptyTable from 'views/Components/Shared/Components/EmptyTable';

export const monthColumns = months.map((month) => ({
	field: month,
	headerName: monthsNames[month].toUpperCase().slice(0, 3),
	headerClassName: 'header border-bottom',
	cellClassName: (params) => {
		return params.value?.has_changed ? 'changed' : '';
	},
	renderCell: (params) => {
		const monthData = params.value;

		return <MonthDataField data={monthData} />;
	},
	width: 60,
	resizable: false,
	sortable: false,
	headerAlign: 'center',
}));

export const columns = [
	{
		...GRID_DETAIL_PANEL_TOGGLE_COL_DEF,
		headerClassName: 'header border-bottom no-padding border-right border-left',
		cellClassName: 'no-padding',
		renderCell: (params) => (
			<CustomDetailPanelToggle id={params.id} value={params.value} />
		),
		width: 30,
		resizable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'sku',
		headerName: 'SKU',
		headerClassName: 'header border-bottom border-right border-left',
		minWidth: 60,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'modified_by',
		headerName: 'Modificado por',
		headerClassName: 'header border-bottom border-right',
		minWidth: 50,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
	},
	{
		field: 'created_at',
		headerName: 'Fecha de modificación',
		headerClassName: 'header border-bottom border-right',
		minWidth: 50,
		flex: 1,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		align: 'center',
		valueFormatter: (value) => {
			if (value == null) {
				return '';
			}
			return formatDate(value);
		},
	},
	{
		field: 'info',
		headerName: '',
		headerClassName: 'header border-bottom',
		renderCell: () => <InfoField />,
		width: 50,
		resizable: false,
		sortable: false,
		headerAlign: 'center',
		// align: 'center',
	},
	...monthColumns,
];

export const slots = {
	noRowsOverlay: EmptyTable,
	noResultsOverlay: EmptyTable,
};

export function getColumnGroups(year) {
	return [
		{
			groupId: 'General',
			headerClassName: 'header border-bottom border-right',
			children: [
				{
					field: '__detail_panel_toggle__',
				},
				{
					field: 'sku',
				},
				{
					field: 'modified_by',
				},
				{
					field: 'created_at',
				},
			],
		},
		{
			groupId: `Forecast ${year}`,
			headerClassName: 'header border-bottom',

			children: [
				{
					field: 'info',
				},
				{
					field: 'jan',
				},
				{
					field: 'feb',
				},
				{
					field: 'mar',
				},
				{
					field: 'apr',
				},
				{
					field: 'may',
				},
				{
					field: 'jun',
				},
				{
					field: 'jul',
				},
				{
					field: 'aug',
				},
				{
					field: 'sep',
				},
				{
					field: 'oct',
				},
				{
					field: 'nov',
				},
				{
					field: 'dec',
				},
			],
		},
	];
}

export const getRowId = (row) => row?.id;
export const rowsPerPageOptions = [5, 10, 25];

export const getDetailPanelHeight = () => 'auto';
export const getRowHeight = () => 60;

export const gridStyles = {
	'& .MuiDataGrid-cell': {
		borderBottom: '1px solid #E0E0E0',
	},

	'& .border-right': {
		borderRight: '1px solid #E0E0E0',
	},
	'& .border-bottom': {
		borderBottom: '1px solid #E0E0E0',
	},
	'& .MuiDataGrid-columnHeader--emptyGroup': {
		borderBottom: '1px solid #E0E0E0',
	},
	'& .header': {
		backgroundColor: '#f5f5f5',
	},

	// '& .MuiDataGrid-scrollbar--vertical': {
	// 	display: 'none',
	// },
	'& .MuiDataGrid-filler': {
		height: 'fit-content !important',
	},
	'& .MuiDataGrid-main': {
		paddingBottom: '16px !important',
	},
	'& .MuiToolbar-root': {
		padding: '0 !important',
	},
	'& .MuiDataGrid-row:hover': {
		backgroundColor: 'transparent !important',
	},

	'& .changed': {
		backgroundColor: '#FFF4E5',
	},
	'& .no-padding': {
		padding: '0 !important',
	},

	height: 'calc(100vh - 260px)',
	// height: '100%',
};
